<template>
  <div>
    <main role="main">
      <div class="wrapper">
        <div class="content-container">
          <h1 class="center has-text-primary has-text-centered">
            User Profile
          </h1>

          <div class="xb-table-block-wrapper">
            <BLoading
              class="xb-loading"
              :is-full-page="true"
              :active.sync="isLoading"
              :can-cancel="false"
              style="z-index: 999;"
            />
            <form class="xb-form">
              <BField class="xb-input" label="Name">
                <BInput :value="data.name" readonly disabled />
              </BField>
              <BField class="xb-input" label="WOG Email">
                <BInput type="email" :value="data.wogEmail" readonly disabled />
              </BField>
              <BField
                grouped
                group-multiline
                class="xb-input"
                label="Cloud ID Email"
              >
                <div class="column is-full is-full-mobile is-paddingless">
                  <BInput
                    type="email"
                    :value="data.cloudIdEmail"
                    readonly
                    disabled
                  />
                </div>
              </BField>
              <BField />
              <BField class="xb-input" label="Office Phone Number">
                <BInput :value="data.phoneNumber" readonly disabled />
              </BField>
              <BField class="xb-input" label="Mobile Number">
                <BInput :value="data.mobileNumber" readonly disabled />
              </BField>
              <BField class="xb-input" label="Active Tenant Code">
                <BInput readonly disabled />
              </BField>
              <BField class="xb-input" label="Active Role">
                <BInput :value="activeRole" readonly disabled />
              </BField>
            </form>
          </div>
        </div>
      </div>
    </main>

    <xbase-footer
      title="ACEAS"
      latestUpdate="16 Aug 2020"
      :services="serviceMenu"
      :links="footerAdditionalLinks"
    />
  </div>
</template>

<script>
const mapGetters = window.Vuex.mapGetters;
const mapState = window.Vuex.mapState;

export default {
  name: "UserProfile",
  data: function() {
    return {
      userId: "",
      data: {
        agencyCode: null,
        name: null,
        WOGEmail: null,
        cloudIdEmail: null,
        phoneNumber: null,
        mobileNumber: null,
        userRole: {}
      }
    };
  },
  computed: {
    ...mapState({
      footerAdditionalLinks: state => state.footer.links
    }),
    ...mapGetters({
      serviceMenu: "menus/headers"
    })
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss">
@media only screen and (max-width: 767px) {
  .xb-header {
    .nav-wrapper {
      left: 0;
      width: 100%;

      .nav-button {
        padding-left: 35px;
      }

      .nav-dropdown.expanded {
        left: 0;
      }
    }
  }
}
</style>
